var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "purchase_part-body row" },
    [
      _c(
        "b-col",
        { staticClass: "purchase_part-body_col", attrs: { md: "4" } },
        [_c("div", { staticClass: "my-2" }, [_vm._t("col1")], 2)]
      ),
      _c(
        "b-col",
        { staticClass: "purchase_part-body_col", attrs: { md: "4" } },
        [_c("div", { staticClass: "my-2" }, [_vm._t("col2")], 2)]
      ),
      _c(
        "b-col",
        { staticClass: "purchase_part-body_col", attrs: { md: "4" } },
        [_c("div", { staticClass: "h-100" }, [_vm._t("col3")], 2)]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }